document.addEventListener('DOMContentLoaded', () => {
  'use strict';

  const preview = document.querySelector(
    '[data-me-live-preview]'
  );

  if (!preview) return;

  const stage = preview.querySelector(
    '[data-me-preview-stage]'
  );

  const productImage = preview.querySelector(
    '[data-me-preview-product-image]'
  );

  const artworkImage = preview.querySelector(
    '[data-me-preview-artwork]'
  );

  const boundary = preview.querySelector(
    '[data-me-preview-boundary]'
  );

  const emptyState = preview.querySelector(
    '[data-me-preview-empty]'
  );

  const placementLabel = preview.querySelector(
    '[data-me-preview-placement]'
  );

  const guideName = preview.querySelector(
    '[data-me-preview-guide-name]'
  );

  const guideDimensions = preview.querySelector(
    '[data-me-preview-guide-dimensions]'
  );

  const guidePlacement = preview.querySelector(
    '[data-me-preview-guide-placement]'
  );

  const previewStatus = preview.querySelector(
    '[data-me-preview-status]'
  );

  const customerGroup =
    preview.dataset.meCustomerGroup ===
    'youth'
      ? 'youth'
      : 'adult';

  let media = {
    front:
      stage?.dataset.frontImage || '',

    back:
      stage?.dataset.backImage || '',

    leftSleeve:
      stage?.dataset.leftSleeveImage ||
      stage?.dataset.frontImage ||
      '',

    rightSleeve:
      stage?.dataset.rightSleeveImage ||
      stage?.dataset.frontImage ||
      ''
  };

  const classes = [
    'is-left-chest',
    'is-center-chest',
    'is-right-chest',
    'is-full-front',
    'is-full-back',
    'is-upper-back',
    'is-back-collar',
    'is-left-sleeve',
    'is-right-sleeve'
  ];

  const placements = {
    'Left Chest': {
      className: 'is-left-chest',
      view: 'front',
      adult: [4, 2],
      youth: [3, 1.5],
      guide:
        'Approximately 4 inches down from the collar.'
    },

    'Center Chest': {
      className: 'is-center-chest',
      view: 'front',
      adult: [8, 4],
      youth: [6, 3],
      guide:
        'Approximately 3 to 4 inches down from the collar.'
    },

    'Right Chest': {
      className: 'is-right-chest',
      view: 'front',
      adult: [4, 2],
      youth: [3, 1.5],
      guide:
        'Approximately 4 inches down from the collar.'
    },

    'Full Front': {
      className: 'is-full-front',
      view: 'front',
      adult: [11, 11],
      youth: [9, 9],
      guide:
        'Approximately 3 to 4 inches down from the collar.'
    },

    'Full Back': {
      className: 'is-full-back',
      view: 'back',
      adult: [12, 14],
      youth: [10, 12],
      guide:
        'Approximately 3 inches down from the back collar.'
    },

    'Upper Back': {
      className: 'is-upper-back',
      view: 'back',
      adult: [12, 4],
      youth: [10, 2.5],
      guide:
        'Approximately 4 inches down from the back collar.'
    },

    'Back Collar': {
      className: 'is-back-collar',
      view: 'back',
      adult: [2, 2],
      youth: [1.5, 1.5],
      guide:
        'Approximately 1 to 2 inches below the back collar.'
    },

    'Left Sleeve': {
      className: 'is-left-sleeve',
      view: 'leftSleeve',
      adult: [2, 2],
      youth: [1.5, 1.5],
      guide:
        'Approximately 1 inch above the sleeve hem.'
    },

    'Right Sleeve': {
      className: 'is-right-sleeve',
      view: 'rightSleeve',
      adult: [2, 2],
      youth: [1.5, 1.5],
      guide:
        'Approximately 1 inch above the sleeve hem.'
    }
  };

  function setPlacement(
    placementName,
    artworkUrl = ''
  ) {
    const placement =
      placements[placementName] ||
      placements['Left Chest'];

    const dimensions =
      placement[customerGroup] ||
      placement.adult;

    boundary?.classList.remove(
      ...classes
    );

    boundary?.classList.add(
      placement.className
    );

    const imageUrl =
      media[placement.view] ||
      media.front;

    if (productImage && imageUrl) {
      productImage.src = imageUrl;
      productImage.srcset = '';
    }

    if (placementLabel) {
      placementLabel.textContent =
        placementName;
    }

    if (guideName) {
      guideName.textContent =
        placementName;
    }

    if (guideDimensions) {
      guideDimensions.textContent =
        `${dimensions[0]}″ × ${dimensions[1]}″`;
    }

    if (guidePlacement) {
      guidePlacement.textContent =
        placement.guide;
    }

    if (artworkUrl) {
      artworkImage.src = artworkUrl;
      artworkImage.hidden = false;

      if (emptyState) {
        emptyState.hidden = true;
      }

      if (previewStatus) {
        previewStatus.textContent =
          `Previewing ${placementName}`;
      }
    } else {
      artworkImage.src = '';
      artworkImage.hidden = true;

      if (emptyState) {
        emptyState.hidden = false;
      }

      if (previewStatus) {
        previewStatus.textContent =
          `Upload artwork for ${placementName}`;
      }
    }
  }

  window.addEventListener(
    'me:preview-placement',
    (event) => {
      setPlacement(
        event.detail?.placement ||
        'Left Chest',

        event.detail?.artworkUrl ||
        ''
      );
    }
  );

  window.addEventListener(
    'me:product-media-changed',
    (event) => {
      media = {
        front:
          event.detail?.frontImage ||
          media.front,

        back:
          event.detail?.backImage ||
          event.detail?.frontImage ||
          media.front,

        leftSleeve:
          event.detail
            ?.leftSleeveImage ||
          event.detail?.frontImage ||
          media.front,

        rightSleeve:
          event.detail
            ?.rightSleeveImage ||
          event.detail?.frontImage ||
          media.front
      };

      const currentPlacement =
        placementLabel?.textContent ||
        'Left Chest';

      setPlacement(
        currentPlacement,
        artworkImage?.hidden
          ? ''
          : artworkImage?.src || ''
      );
    }
  );

  setPlacement('Left Chest');
});